import { Component, OnInit, ViewChild } from '@angular/core';
import { PracticeService } from 'src/app/services/practice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Practice } from 'src/app/models/practice';
import { NotificationService } from 'src/app/services/notification.service';
import { Programme } from 'src/app/models/programme';
import { Course } from 'src/app/models/course';
import {MatDialog} from '@angular/material/dialog';
import { CoursePickerComponent } from 'src/app/components/modals/course-picker/course-picker.component';
import { ProgrammeCourse } from 'src/app/models/programmeCourse';
import { MatTableDataSource, MatPaginator } from '@angular/material';
import { AddMemberComponent } from 'src/app/components/modals/add-member/add-member.component';
import { ProgrammeMember } from 'src/app/models/programmeMember';
import { PracticeContentPickerComponent } from 'src/app/components/modals/practice-content-picker/practice-content-picker.component';

@Component({
  selector: 'app-programme',
  templateUrl: './programme.component.html',
  styleUrls: ['./programme.component.scss']
})
export class ProgrammeComponent implements OnInit {
  public practice: Practice;
  public practiceId;
  public loadedPractice:boolean=false;
  public programmeId;
  public programme: Programme;
  public loadedProgramme:boolean=false;
  public lastNameFilter:string='';
  public datasource:MatTableDataSource<any>;
  displayedColumns: string[] = ['status' ,'first_name', 'last_name', 'email', 'delete'];
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  constructor(
    public dialog: MatDialog,
    private _practice: PracticeService,
    private _route: ActivatedRoute,
    private _notify: NotificationService,
    private _router: Router
  ) {
    this.practiceId = this._route.snapshot.paramMap.get("practiceId");
    this.programmeId = this._route.snapshot.paramMap.get("programmeId");
  }

  notifyAllMembers(){
    if(confirm('Notify all programme members of programme availability?')){
      this._practice.notifyMembers(this.programmeId).subscribe(res=>{
        // console.log(res);
      });
    }
  }

  addMember(){
    const dialogRef = this.dialog.open(AddMemberComponent, {
      width: '450px',
      panelClass: 'ng-modal-custom',
      data: {members: this.practice.members.filter(member=>{
        let result=true;
        this.programme.members.forEach(m=>{
          if(m.member.id==member.id) result=false;
        });
        return result;
      })}
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        result.forEach(member=>{
          let m = new ProgrammeMember;
          m.user_id=member.id;
          m.programme_id=this.programmeId;
          m.member=member;
          this.programme.members.push(m);
        });
        this.datasource= new MatTableDataSource<any>(this.programme.members);
        this.datasource.paginator=this.paginator;
      }
    });
  }

  removeMember(id:number){
    this.programme.members.forEach((member, index)=>{
      if(member.user_id==id) {
        this.programme.members.splice(index, 1);
        this.datasource= new MatTableDataSource<any>(this.programme.members);
        this.datasource.paginator=this.paginator;
        return;
      }
    })
  }

  filterLastName(){
    if(!this.lastNameFilter) {
      this.datasource= new MatTableDataSource<any>(this.programme.members);
      this.datasource.paginator=this.paginator;
      return;
    }
    let filterVal=this.lastNameFilter.toLowerCase();
    this.datasource= new MatTableDataSource<any>(this.programme.members.filter(member=>{
      return member.member.last_name.toLowerCase().search(filterVal) > -1;
    }));
    this.datasource.paginator=this.paginator;
  }

  public getPractice(){
    this._practice.getPractice(this.practiceId).subscribe(
      res=>{
        this.practice=new Practice(res);
        this.loadedPractice=true;
      }
    );
  }

  public getProgramme(){
    this._practice.getProgramme(this.programmeId).subscribe(
      res=>{
        this.programme=new Programme(res);
        this.loadedProgramme=true;
        this.datasource = new MatTableDataSource<any>(this.programme.members);
        this.datasource.paginator=this.paginator;
      }
    );
  }

  formatStartDate(event){
    this.programme.start_date=event.value.toISOString();
  }

  formatCloseDate(event){
    this.programme.close_date=event.value.toISOString();
  }

  removeCourse(id:number){
    this.programme.courses.forEach((course, index)=>{
      if(course.course_id==id) this.programme.courses.splice(index, 1);
    });
  }

  addPracticeContent(){
    const dialogRef = this.dialog.open(PracticeContentPickerComponent, {
      width: '400px',
      panelClass: 'ng-modal-custom',
      data: {practiceId: this.practiceId}
    });

    dialogRef.afterClosed().subscribe(
      res=>{
        if(res){
          res.forEach(result=>{
            let pCourse = new ProgrammeCourse;
            pCourse.course_id = result.id;
            pCourse.programme_id = this.programme.id;
            pCourse.course = result;
            this.programme.courses.push(pCourse);
          });
        }
      }
    );
  }

  addCourse(){
    const dialogRef = this.dialog.open(CoursePickerComponent, {
      width: '850px',
      panelClass: 'ng-modal-custom'
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        let pCourse = new ProgrammeCourse;
        pCourse.course_id = result.id;
        pCourse.programme_id = this.programme.id;
        pCourse.course = result;
        this.programme.courses.push(pCourse);
      }
    });
  }

  public saveChanges(){
    if(this.programme.name=='') return this._notify.showMessage('Programme name must not be blank.', 'OK');
    this._practice.updatePracticeProgramme(this.programme).subscribe(
      res=>{
        console.log(res);
        this._notify.showMessage('Programme updated.', 'OK');
      }
    );
  }

  ngOnInit() {
    this.getPractice();
    this.getProgramme();
  }

}
